import React from "react";

import AccessUser from "./AccessUser";
import ExclusiveMode from './ExclusiveMode'
import UserChangePassword from './UserChangePassword'
import SimultaneousAccessByPlataform from './SimultaneousAccessByPlataform'

const UserAccessConfiguration = (props) => {
    let isEdit = props.selectedUserId != undefined && props.selectedUserId != null && props.selectedUserId > 0;

    return (
        <div className="row bottom-separator-xs">
            <div className="col-xs-12">
                <h3 className="divisor-section">Configuración de acceso</h3>
            </div>
            {props.isGyFSecurity == true && <div className="col-xs-12 bottom-separator-xs">
                {isEdit &&
                    <AccessUser cambioClave={props.informacionUsuario.Cambio_Clave}
                        updateInformacionUsuario={props.updateInformacionUsuario} />}
                <UserChangePassword
                    clave={props.informacionUsuario.Clave}
                    configuracionPwSesion={props.configuracionPwSesion}
                    isEdition={isEdit}
                    updateInformacionUsuario={props.updateInformacionUsuario}
                    passWordChange={props.passWordChange}
                    passWordUnChange={props.passWordUnChange} />
            </div>}
            <div className="col-xs-12 bottom-separator-xs">
                <ExclusiveMode
                    modoExclusivo={props.modoExclusivo}
                    productos={props.productos}
                    addModoExclusivo={props.addModoExclusivo}
                    deleteModoExclusivo={props.deleteModoExclusivo} />
            </div>
            <div className="col-xs-12 bottom-separator-xs">
                <SimultaneousAccessByPlataform
                    tipoPlataforma={props.tipoPlataforma}
                    accesosPorPlataforma={props.accesosPorPlataforma}
                    setAccesosSimultaneosPorPlataforma={props.setAccesosSimultaneosPorPlataforma}
                    usuarioTipoPlataforma={props.informacionUsuario.PlataformaId}
                    updateInformacionUsuario={props.updateInformacionUsuario} />
            </div>
        </div>
    );
}

export default UserAccessConfiguration;